<template>
  <div style="display: grid; grid-template-rows: 1fr auto; justify-content: center; justify-items: center; height: 100%">
    <div id="responseZone" class="smallMargin paddingRound flexwrap centercenter">



      <div class="lettersResponse flexwrap centercenter paddingRound mediumRoundAngles mediumShadow"
           :class="{plainGoldTheme:level>=3, plainSilverTheme:level==2, plainCopperTheme:level==1, plainStandardTheme:level==0, }"
           :style="currentAnswer.join('') === answer.replace(/\s/g, '')?'background-color: #50fd86;color: #212121;':''">
        <span v-if="sameLanguage && (goodAnswer || pass)">{{ answer }} = {{ answerTrad }}</span>
        <span v-else-if="pass">{{ answer }}</span>
        <span v-else>{{ joinedCurrentAnswer }}</span>
      </div>
    </div>


    <div class="flexwrap centercenter" style="min-width: 90%">
      <div class="lettersKeys flexwrap">
        <div v-for="(letter, index) in proposedLetters" :key="index">
          <div style="margin: 0.1vw" @click="letterToResponse(index)" :class="{clickable:!letter.clicked, }">
            <div class="letter verySmallRoundAngles "

                 :class="{smallShadow: !letter.clicked, letterClicked:letter.clicked, plainGoldTheme:level>=3&&!letter.clicked, plainSilverTheme:level==2&&!letter.clicked, plainCopperTheme:level==1&&!letter.clicked, plainStandardTheme:level==0&&!letter.clicked,}"
            >
              {{ letter.letter }}
            </div>
          </div>

        </div>
      </div>
      <div class="lettersmall verySmallRoundAngles" :class="{smallShadow: currentAnswer.length > 0, letterClicked:currentAnswer.length==0, plainGoldTheme:level>=3&&currentAnswer.length > 0, plainSilverTheme:level==2&&currentAnswer.length > 0, plainCopperTheme:level==1&&currentAnswer.length > 0, plainStandardTheme:level==0&&currentAnswer.length > 0, clickable:currentAnswer.length > 0, }"
           @click="reset()">
        <i class="fas fa-long-arrow-alt-left"></i>
      </div>
    </div>


  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "spellingAnswer",

  props: {
    answer: String,
    pass: Boolean,
    sameLanguage: Boolean,
    answerTrad: String,
  },

  created() {
    this.shuffleLetters.forEach((letter) => {
      this.proposedLetters.push({
        letter: letter,
        clicked: false
      })
    })
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    ...mapGetters('session', [
      'currentWord'
    ]),

    level: function () {
      if (this.currentWord.lemma.user_lemma.length > 0) {
        return this.currentWord.lemma.user_lemma[0].knowledge_level
      }
      return 0
    },

    joinedCurrentAnswer:function (){
      let j=0
      let joinedanswer=""
      this.answer.split(' ').forEach(word => {
        joinedanswer += this.currentAnswer.join('').split('').slice(j, j+word.length).join('')
        joinedanswer += ' '
            j+=word.length
      })
      return joinedanswer
    },

    shuffleLetters: function() {
      let tab = []

      if(this.answer.replace(/\s/g, '').length<=7){
        tab = this.answer.replace(/\s/g, '').split('');
      }
      else{
        const syllableRegex = /[^aeiouy]*[aeiouy]+(?:[^aeiouy]*$|[^aeiouy](?=[^aeiouy]))?/gi;

        this.answer.split(' ').forEach(word => {
          tab = tab.concat(word.match(syllableRegex))
          })

      }

      let tempTab = tab.slice();

      for (var i = tab.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = tempTab[i];
        tempTab[i] = tempTab[j];
        tempTab[j] = temp;
      }
      return tempTab
    },
  },

  watch: {
    pass: function() {
      this.$emit('goodAnswer', false)
    },
    currentAnswer: function() {
      if(this.currentAnswer.join('') === this.answer.replace(/\s/g, '')) {
        this.goodAnswer = true;
        this.$emit('goodAnswer', true);
        return true
      }
      this.goodAnswer = false;
      return false
    }
  },

  methods: {
    letterToResponse(index) {
      if(!this.proposedLetters[index].clicked) {
        this.proposedLetters[index].clicked = true;
        this.currentAnswer.push(this.proposedLetters[index].letter)
      }
    },

    reset() {
      /*this.proposedLetters = [];
      this.currentAnswer = [];*/
      let remove = this.currentAnswer.pop()
      this.proposedLetters.some((letter) => {
        if(letter.letter==remove && letter.clicked==true)
        {
          letter.clicked=false
          return 1
        }
      })
    }
  },

  data() {
    return {
      proposedLetters: [],
      currentAnswer: [],
      goodAnswer: false
    }
  }

}
</script>

<style scoped>
#responseZone {
  width: fit-content;
  min-width: 10vw;
  min-height: 2vw;
  align-content: flex-end;
  text-align: center;
}

.lettersResponse {
  display: flex;
  flex-direction: row;
  font-size: 200%;
  font-weight: bold;
  min-width: 20vw;
  min-height: 3vw;
}

.lettersKeys {
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  align-items: center;
  justify-items: center;
  justify-content: center;
}

.letter {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 2vw;
  margin: 0.3vw;
  width: fit-content;
  padding: 0 0.5vw 0 0.5vw;
  height: 3vw;
  font-weight: bold;
  font-size: 1.5em;
}

.lettersmall {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5vw;
  width: 2vw;
  height: 2vw;
  font-weight: bold;
  font-size: 1.2em;
}

.letterClicked{
  background-color: #39393988;
  color: rgba(255, 255, 255, 0.45);
}

.down {
  border-style: inset;
}

@media screen and (max-device-width: 767px) {
  #responseZone {
    min-width: 40vw;
    min-height: 8vw;
    align-content: flex-end;
    text-align: center;
  }


  .lettersResponse {
    display: flex;
    flex-direction: row;
    font-size: 200%;
    font-weight: bold;
    min-width: 60vw;
    min-height: 12vw;
  }
  .lettersKeys {
    max-width: 80%;
  }

  .letter {
    height: 13vw;
    margin: 1.5vw;
    min-width: 11vw;
    width: fit-content;
    padding: 0 1vw 0 1vw;
    font-weight: bold;
    font-size: 1.7em;
  }

  .lettersmall {
    margin-left: 3vw;
    width: 8vw;
    height: 8vw;
    font-weight: bold;
    font-size: 1.2em;
  }
}
</style>